module.exports = __webpack_public_path__ + "static/media/27OCHA20.6e43db62.jpg";